import { api } from '@services';

import EquipmentStatus, {
  EquipmentStatusCategoryOptions,
} from '@models/EquipmentStatus.model';

interface IUpdateEquipmentStatus {
  id: string;
  studioId: string;
  name?: string;
  description?: string | null;
  category?: EquipmentStatusCategoryOptions;
  isDefault?: boolean;
}

const updateEquipmentStatus = async ({
  id,
  ...data
}: IUpdateEquipmentStatus): Promise<EquipmentStatus> => {
  const { data: equipmentStatus } = await api.patch<EquipmentStatus>(
    `/equipmentStatus/${id}`,
    data,
  );

  return EquipmentStatus.fromApiModel(equipmentStatus);
};

export { updateEquipmentStatus };
